import { Row } from 'antd';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import cover from '/cover.png';

interface CoverProps {
  children?: React.ReactNode;
  style?: CSSProperties | undefined;
}
const CoverImage: React.FC<CoverProps> = function ({ children, style }) {
  return (
    <Cover align="middle" style={style}>
      {children}
    </Cover>
  );
};

export default CoverImage;

const Cover = styled(Row)`
  background-image: linear-gradient(90deg, rgba(224, 222, 211, 0%), rgb(68 69 75 / 87%)), url(${cover});
  background-size: cover;
  right: 0;
  left: 0;
  position: absolute;
`;
